import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { Product } from 'schema-dts'
import { ProductData, MagentoProductStockStatus } from 'lib/types'
import { useStoreConfig } from 'lib/core/hooks'
import { useHistory } from 'react-router-dom'

interface Props {
  product: ProductData
}

export const JsonLdProduct = ({ product }: Props) => {
  const history = useHistory()
  const { pwaUrl } = useStoreConfig()
  const productPath = product?.canonicalUrl ?? product?.urlKey

  const offers: any = {
    '@type': 'Offer',
    price: product.price.regularPrice.amount.value,
    priceCurrency: product.price.regularPrice.amount.currency
  }

  if (!process.env.REACT_APP_JSON_LD_DISABLE_PRODUCT_STOCK) {
    offers.availability = product.stockStatus === MagentoProductStockStatus.IN_STOCK ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'
  }

  return (
    <JsonLd<Product>
      item={{
        '@context': 'https://schema.org',
        '@type': 'Product',
        description: product.metaDescription,
        name: product.name,
        image: product.image.default.url,
        sku: product.sku,
        url: `${pwaUrl ?? ''}/${productPath ?? history.location.pathname.substr(1)}`,
        offers
      }}
    />
  )
}
